export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/number.js
// module id = 24
// module chunks = 0